import type { ReactNode } from "react";

const B = ({ children }: { children: ReactNode }) => (
  <strong className="font-medium text-[var(--color-fg)]">{children}</strong>
);

const today: ReactNode[] = [
  <><B>Legal AI agents:</B> document extraction, form-filling, compliance checking, case processing. Immigration fully built.</>,
  <><B>AI-driven services for law firms:</B> website build, branding, design, marketing automation, IT management. Delivered at near-zero marginal cost. Our entry point into new firms.</>,
];

const next: ReactNode[] = [
  <><B>Legal expansion:</B> conveyancing, wills, family law, IP.</>,
  <><B>Fund Ops & Compliance:</B> regulatory monitoring, KYC/AML investor onboarding, fund admin, marketing materials review.</>,
  <><B>Accounting:</B> audit prep, tax compliance, bookkeeping, management accounts. The deepest cross-sell with legal and compliance.</>,
];

export function V3WhatWeDoSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[28px] font-light tracking-tight leading-tight mb-5 font-[family-name:var(--font-heading)]">
        We go inside the firm. We run the agents.<br />They get the work done.
      </h2>

      <div className="grid grid-cols-2 gap-6">
        {/* LHS — What we deliver today */}
        <div>
          <div className="text-[11px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-accent)] uppercase tracking-[0.1em] mb-3 pb-2 border-b border-[var(--color-border)]">
            What we deliver today
          </div>
          <ul className="space-y-2.5">
            {today.map((t, i) => (
              <li key={i} className="flex items-start gap-2 text-[12px] text-[var(--color-fg-secondary)] leading-relaxed">
                <span className="w-1 h-1 rounded-full bg-[var(--color-accent)] mt-[7px] shrink-0" />
                <span>{t}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* RHS — Where we expand next */}
        <div>
          <div className="text-[11px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-fg-tertiary)] uppercase tracking-[0.1em] mb-3 pb-2 border-b border-[var(--color-border)]">
            Where we expand next
          </div>
          <ul className="space-y-2.5">
            {next.map((v, i) => (
              <li key={i} className="flex items-start gap-2 text-[12px] text-[var(--color-fg-secondary)] leading-relaxed">
                <span className="w-1 h-1 rounded-full bg-[var(--color-fg-tertiary)] mt-[7px] shrink-0" />
                <span>{v}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* XENI callout — most advanced deployment */}
      <div className="mt-5 border-l-2 border-[var(--color-accent)] pl-4 py-2">
        <div className="text-[10px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-accent)] uppercase tracking-[0.15em] mb-1">
          XENI · Most advanced deployment
        </div>
        <p className="text-[12px] text-[var(--color-fg-secondary)] leading-relaxed font-light">
          <B>100% AI-delivered</B> immigration service with licensed immigration experts. Full automation, professional sign-off only.
        </p>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light leading-relaxed">
          One engine across all verticals. The rules change. The engine doesn&apos;t. <strong className="font-medium text-[var(--color-fg)]">The firm gets completed work, not software to learn.</strong>
        </p>
      </div>
    </div>
  );
}
